import type { ButtonHTMLAttributes } from 'react'
import styles from './Button.module.css'

type Variant = 'primary' | 'secondary' | 'danger'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
  /** The shorter footer-pair geometry from the pallet screen. */
  compact?: boolean
}

export function Button({
  variant = 'primary',
  compact = false,
  className,
  type = 'button',
  ...rest
}: ButtonProps) {
  const classes = [styles.button, styles[variant], compact ? styles.compact : '', className ?? '']
    .filter(Boolean)
    .join(' ')

  return <button type={type} className={classes} {...rest} />
}
